<template>
	<div class="panel-view">
		<slot />
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.panel-view {
		& > * {
			padding-bottom: 20px;
			

			&:last-child {
				margin-bottom: 	0;
				padding-bottom: 0;
				border-bottom: 	none;
			}
		}
	}
</style>